// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__nLsLQ","dark":"BaseLayout_dark__5o1bI","light":"BaseLayout_light__mqasy"};